var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97586 4.23218H7.95162C7.66071 4.23218 7.39404 4.4746 7.39404 4.78975C7.39404 5.1049 7.63647 5.34733 7.95162 5.34733H7.97586C8.26677 5.34733 8.53344 5.1049 8.53344 4.78975C8.53344 4.4746 8.29101 4.23218 7.97586 4.23218Z",
    fill: "#637381"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97579 6.14734C7.68488 6.14734 7.41821 6.38976 7.41821 6.70491V10.4382C7.41821 10.7292 7.66064 10.9958 7.97579 10.9958C8.2667 10.9958 8.53336 10.7534 8.53336 10.4382V6.68067C8.53336 6.38976 8.29094 6.14734 7.97579 6.14734Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97583 0.038208C3.92734 0.038208 0.630371 3.31094 0.630371 7.35942C0.630371 11.4079 3.92734 14.7049 7.97583 14.7049C12.0243 14.7049 15.297 11.4079 15.297 7.35942C15.297 3.31094 12.0243 0.038208 7.97583 0.038208ZM7.97583 13.614C4.5334 13.614 1.72128 10.8018 1.72128 7.35942C1.72128 3.917 4.5334 1.10487 7.97583 1.10487C11.4183 1.10487 14.2061 3.917 14.2061 7.35942C14.2061 10.8018 11.4183 13.614 7.97583 13.614Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg48);
export default __webpack_public_path__ + "static/media/svg48.41efc52584fe82719f3df94fd6e19a3b.svg";
export { ForwardRef as ReactComponent };